import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { optionStyles } from './CicReasonOption.styles';

const CicReasonOption = ({ option, optionText }) => (
  <Box sx={optionStyles}>
    <Typography variant="regular16">{optionText}</Typography>
    {!!option.description && (
      <Typography color="text.secondary" variant="regular12">
        {option.description}
      </Typography>
    )}
  </Box>
);

CicReasonOption.propTypes = {
  option: PropTypes.shape({
    description: PropTypes.string,
  }).isRequired,
  optionText: PropTypes.string.isRequired,
};

export default memo(CicReasonOption);
